import { defaultText } from '@phaser/helpers/Text';
import { MessageEmitter } from '@phaser/events';
import { DEPTH } from '@phaser/data/depth';
import { Game } from '@phaser/scenes/Game';
import i18next from 'i18next';

export class EnemyDamageNumber {
  private scene: Game = Game.current;

  constructor(
    private x: number,
    private y: number,
    private value: number,
  ) {
    try {
      if (this.value < 0) {
        this._showMiss();
      } else {
        this._showDamage();
        // Taking a real hit breaks the combo
        MessageEmitter.emit('comboBreak');
      }
    } catch {}
  }

  private _showMiss() {
    const text = this.scene.add.text(this.x, this.y, i18next.t('Game.miss'), {
      ...defaultText,
      fontSize: '20px',
      color: '#aaaaaa',
      strokeThickness: 1,
    })
      .setOrigin(0.5)
      .setDepth(DEPTH.DAMAGE_NUMBER);

    this.scene.add.tween({
      targets: text,
      y: this.y - 50,
      alpha: 0,
      ease: 'Power2',
      duration: 600,
      onComplete: () => text.destroy(),
    });
  }

  private _showDamage() {
    const isHeavyHit = this.value >= 80;

    const text = this.scene.add.text(this.x, this.y, `-${this.value}`, {
      ...defaultText,
      fontSize: isHeavyHit ? '36px' : '28px',
      color: isHeavyHit ? '#ff2200' : '#ff6644',
      strokeThickness: isHeavyHit ? 3 : 2,
    })
      .setOrigin(0.5)
      .setDepth(DEPTH.DAMAGE_NUMBER);

    const splat = this.scene.add.image(this.x, this.y, 'sprites', 'damagesplat')
      .setTint(0x880000)
      .setAlpha(0.45)
      .setOrigin(0.5)
      .setDepth(DEPTH.DAMAGE_NUMBER - 1);

    this.scene.add.tween({
      targets: [splat, text],
      y: `-=${Math.random() * 20 + 55}`,
      scale: { from: 0, to: isHeavyHit ? 1.1 : 0.9 },
      ease: 'Power2',
      duration: isHeavyHit ? 350 : 280,
      onComplete: () => {
        this.scene.add.tween({
          targets: [splat, text],
          alpha: 0,
          duration: 320,
          onComplete: () => {
            text.destroy();
            splat.destroy();
          },
        });
      },
    });

    if (isHeavyHit) {
      this.scene.cameras.main.shake(80, 0.007 / window.devicePixelRatio);
    }
  }
}
